<template>
    <div>

        <Head :title="__('Dashboard')" />

        <div class=" w-full py-6 flex items-center space-x-4 justify-end">
            <button @click="exportDashboard" :disabled="isExporting">
                <div class="flex items-center space-x-4 justify-center" v-if="!isExporting">
                    <div>Exporter</div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z" />
                    </svg>
                </div>
                <div class="border-4 size-5 border-blue-800 border-b-0 animate-spin rounded-full" v-else="isExporting">

                </div>
            </button>

        </div>
        <div class="flex flex-col gap-5 badge_items md:flex-row">
            <div class="w-full h-32 cursor-pointer badge__item lg:w-1/4"
                @click="goToLink(this.route('tickets', { 'type': 'new' }))">
                <div class="flex justify-between w-full bg-white rounded-lg l__items">
                    <div class="badge__info">
                        <span class="title">{{ __('Nouveaux tickets') }}</span>
                        <span class="number">{{ new_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="pr-3 round_circle rtl:pl-3">
                            <div class="pie animate"
                                :style="{ '--pie_val': parseInt((new_tickets * 100) / total_tickets) }"> {{
                                    parseInt((new_tickets * 100) / total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full h-32 cursor-pointer badge__item md:w-1/4"
                @click="goToLink(this.route('tickets', { 'type': 'open' }))">
                <div class="flex justify-between w-full bg-white rounded-lg l__items">
                    <div class="badge__info">
                        <span class="title">{{ __('Tickets ouverts') }}</span>
                        <span class="number">{{ opened_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="pr-3 round_circle rtl:pl-3">
                            <div class="pie animate"
                                :style="{ '--pie_val': parseInt((opened_tickets * 100) / total_tickets) }"> {{
                                    parseInt((opened_tickets * 100) / total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full h-32 cursor-pointer badge__item md:w-1/4"
                @click="goToLink(this.route('tickets', { 'search': 'ferme' }))">
                <div class="flex justify-between w-full bg-white rounded-lg l__items">
                    <div class="badge__info">
                        <span class="title">{{ __('Tickets fermés') }}</span>
                        <span class="number">{{ closed_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="pr-3 round_circle rtl:pl-3">
                            <div class="pie animate"
                                :style="{ '--pie_val': parseInt((closed_tickets * 100) / total_tickets) }"> {{
                                    parseInt((closed_tickets * 100) / total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="auth.user.role.slug !== 'customer'" class="w-full h-32 cursor-pointer badge__item md:w-1/4"
                @click="goToLink(this.route('tickets', { 'type': 'un_assigned' }))">
                <div class="flex justify-between w-full bg-white rounded-lg l__items">
                    <div class="badge__info">
                        <span class="title">{{ __('Tickets non affectés') }}</span>
                        <span class="number">{{ un_assigned_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="pr-3 round_circle rtl:pl-3">
                            <div class="pie animate"
                                :style="{ '--pie_val': parseInt((un_assigned_tickets * 100) / total_tickets) }"> {{
                                    parseInt((un_assigned_tickets * 100) / total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-5 mt-8 response__details md:flex-row"
            v-if="auth.user.role.slug !== 'complaint_manager'">
            <div class="w-full">
                <div class="flex flex-col items-center pb-5 pl-5 pr-5 bg-white rounded-lg r__wrapper rd">
                    <h2 class="pt-3 text-lg font-bold th__ttl">{{ __('Ticket par departement') }}</h2>
                    <div class="flex flex-col pt-3 th__info">
                        <vc-donut background="white" foreground="grey" :size="120" unit="px" :thickness="45" has-legend
                            legend-placement="right" :sections="top_departments" :total="100" :start-angle="0"
                            :auto-adjust-text-size="true">
                        </vc-donut>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex flex-col items-center pb-5 pl-5 pr-5 bg-white rounded-lg r__wrapper rd">
                    <h2 class="pt-3 text-lg font-bold th__ttl">{{ __('Tickets par type') }}</h2>
                    <div class="flex flex-col pt-3 th__info">
                        <vc-donut background="white" foreground="grey" :size="120" unit="px" :thickness="45" has-legend
                            legend-placement="right" :sections="top_types" :total="100" :start-angle="0"
                            :auto-adjust-text-size="true">
                        </vc-donut>
                    </div>
                </div>
            </div>
            <!-- <div class="w-full">
              <div class="flex flex-col items-center pb-5 pl-5 bg-white rounded-lg r__wrapper rd">
                  <h2 class="pt-3 text-lg font-bold th__ttl">{{ __('Top ticket creator') }}</h2>
                  <div class="flex flex-col pt-3 th__info">
                      <vc-donut
                          background="white" foreground="grey"
                          :size="120" unit="px" :thickness="45"
                          has-legend legend-placement="right"
                          :sections="top_creators" :total="100"
                          :start-angle="0" :auto-adjust-text-size="true">
                      </vc-donut>
                  </div>
              </div>
          </div> -->
        </div>
        <div class="flex flex-col gap-5 mt-8 response__details md:flex-row" v-if="auth.user.role.slug !== 'customer'">
            <div class="flex flex-col gap-5 md:flex-row md:w-10/12">
                <div class="w-full">
                    <div class="flex flex-col p-5 bg-white rounded-lg r__wrapper rd">
                        <h2 class="pt-3 text-lg font-bold th__ttl">{{ __('Historique des tickets') }}</h2>
                        <div class="flex th__info">
                            <span class="text-2xl font-bold"> {{ chart_line.this_month }} </span>
                            <span class="pt-2 pl-1 pr-1 text-xs">/ {{ __('this month') }}</span>
                            <span class="pt-2 pl-2 pr-2 text-xs font-bold">{{ __('last month') }} {{
                                chart_line.last_month }}</span>
                        </div>
                        <div v-if="months.length" class="flex justify-center w-full c__wrapper ">
                            <div class="flex flex-col items-center w-full gap-3 c__line" v-for="cl in months">
                                <span class="cl__b" :style="{ '--cl_value': cl.value }"></span>
                                <span class="text-xs cl__n">{{ cl.month }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full rd md:w-2/5">
                    <div class="flex flex-col pb-5 pl-5 pr-5 bg-white rounded-lg r__wrapper rd">
                        <div class="res__info">
                            <span class="text-xl font-bold">{{ __('Délai de première réponse') }}</span>
                            <span class="res_avg">{{ __('Average') }}</span>
                            <div class="flex justify-start">
                                <div v-if="firstResponse.length" v-for="(fr, fri) in firstResponse"
                                    class="pr-5 res_time" :key="fri">
                                    <span class="num">{{ fr[0] }}</span>
                                    <span class="text">{{ __(fr[1]) }}</span>
                                </div>
                                <div v-else class="pr-5 res_time">
                                    0
                                </div>
                            </div>
                        </div>
                        <div class="tc__info">
                            <span class="text-xl font-bold">{{ __('Délai de dernière réponse') }}</span>
                            <span class="res_avg">{{ __('Average') }}</span>
                            <div class="flex justify-start">
                                <div v-if="lastResponse.length" v-for="(fr, fri) in lastResponse" class="pr-5 res_time"
                                    :key="fri">
                                    <span class="num">{{ fr[0] }}</span>
                                    <span class="text">{{ __(fr[1]) }}</span>
                                </div>
                                <div v-else class="pr-5 res_time">
                                    0
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-5 md:w-2/12">
                <!-- <div class="w-full h-32 cursor-pointer badge__item" @click="goToLink(this.route('users'))">
                  <div class="flex justify-between w-full bg-white rounded-lg l__items">
                      <div class="badge__info">
                          <span class="title">{{ __('Customers') }}</span>
                          <span class="number">{{ total_customer }}</span>
                      </div>
                      <div class="a__right">
                          <icon name="pending_users" class="h-5 ml-5 mr-5 fill-gray-400" />
                      </div>
                  </div>
              </div> -->
                <div class="w-full h-32 cursor-pointer badge__item" @click="goToLink(this.route('contacts'))">
                    <div class="flex justify-between w-full bg-white rounded-lg l__items">
                        <div class="badge__info">
                            <span class="title">{{ __('Contacts') }}</span>
                            <span class="number">{{ total_contacts }}</span>
                        </div>
                        <div class="a__right">
                            <icon name="contact" class="h-5 ml-5 mr-5 fill-gray-400" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Loading Process -->
        <div v-if="loading" class="processing-overlay">
            <div class="background"></div>
            <div class="loader">
                `<svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"
                    style="background: none;">
                    <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.875s"></animate>
                    </circle>
                    <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.75s"></animate>
                    </circle>
                    <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.625s"></animate>
                    </circle>
                    <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.5s"></animate>
                    </circle>
                    <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.375s"></animate>
                    </circle>
                    <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.25s"></animate>
                    </circle>
                    <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.125s"></animate>
                    </circle>
                    <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="0s"></animate>
                    </circle>
                </svg>`
            </div>
        </div>
        <!-- Loading Process -->

    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import { ref } from 'vue';
import { router } from '@inertiajs/vue3';

export default {
    metaInfo: { title: 'Dashboard' },
    components: {
        Head,
        Icon,
        Link,
    },
    layout: Layout,
    props: {
        auth: Object,
        entries: Array,
        chart_line: Object,
        api_key: String,
        new_tickets: Number,
        total_tickets: Number,
        un_assigned_tickets: Number,
        opened_tickets: Number,
        closed_tickets: Number,
        first_response: Array,
        top_creators: Array,
        last_response: Array,
        top_departments: Array,
        top_types: Array,
        total_customer: Number,
        total_contacts: Number,
    },
    data() {
        return {
            errors: [],
            loading: false,
            firstResponse: [],
            lastResponse: [],
            months: [],
            isExporting: false
        }
    },
    created() {
        for (let i = 0; i < this.first_response.length; i++) {
            if (i % 2 === 0) {
                this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i + 1]]]
            }
        }
        for (let i = 0; i < this.last_response.length; i++) {
            if (i % 2 === 0) {
                this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i + 1]]]
            }
        }

        this.months = this.chart_line.previousMonths.map(m => {
            return { 'month': m, 'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100) / this.chart_line.total) + '%' : '0%' }
        })
    },
    methods: {
        goToLink(link) {
            window.location.href = link;
        },
        async exportDashboard() {
            this.isExporting = true;

            try {
                const response = await fetch(route('export'), {
                    headers: {
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                });

                if (!response.ok) {
                    throw new Error('Export failed');
                }

                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `dashboard_${new Date().toISOString().split('T')[0]}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);

            } catch (e) {
                console.error(e);
            } finally {
                this.isExporting = false;
            }
        }

    },
}
</script>
